"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeImportOpenApiIn = void 0;
class EventTypeImportOpenApiIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventTypeImportOpenApiIn.attributeTypeMap;
    }
}
exports.EventTypeImportOpenApiIn = EventTypeImportOpenApiIn;
EventTypeImportOpenApiIn.discriminator = undefined;
EventTypeImportOpenApiIn.attributeTypeMap = [
    {
        "name": "spec",
        "baseName": "spec",
        "type": "{ [key: string]: any; }",
        "format": ""
    },
    {
        "name": "specRaw",
        "baseName": "specRaw",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=EventTypeImportOpenApiIn.js.map